import { FileParameter } from "services/api/cplapi/CPLAPI";

/* eslint @typescript-eslint/no-explicit-any: 0 */
export class CommentUpdateModel implements ICommentUpdateModel {
  commentID?: number;
  message?: string | undefined;
  private?: boolean;
  deletedAttachmentIDs?: number[] | undefined;
  newAttachments?: FileParameter[] | undefined;

  constructor(data?: ICommentUpdateModel) {
    if (data) {
      for (const property in data) {
        if (Object.hasOwn(data, property)) (this as any)[property] = (data as any)[property];
      }
    }
  }
}

export interface ICommentUpdateModel {
  commentID?: number;
  message?: string | undefined;
  private?: boolean;
  deletedAttachmentIDs?: number[] | undefined;
  newAttachments?: FileParameter[] | undefined;
}
